module.exports = __webpack_public_path__ + "close.png";